import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicComponentLoaderModule } from 'src/app/shared/dynamic-component-loader/dynamic-component-loader.module';
import { DYNAMIC_COMPONENT } from 'src/app/shared/dynamic-component-loader/dynamic-component.manifest';
import { PanelsModule } from 'src/app/shared/components/panels/panels.module';

@NgModule({
  declarations: [
    HomeComponent
  ],
  exports: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    DynamicComponentLoaderModule,
    PanelsModule
  ],
  providers: [
    {provide: DYNAMIC_COMPONENT, useValue: HomeComponent},
  ],
})
export class HomeModule { }
